import { useState } from 'react'
import { useAuth } from '../store/auth'
import { Botao, Card, Erro, Titulo } from '../components/ui'
import { CampoDeSenha, mensagemDeErro } from '../components/CampoDeSenha'

/**
 * Trocar a própria senha, estando logado.
 *
 * Pede a senha atual mesmo havendo sessão: o token do console vive 10 minutos
 * e fica em localStorage, e a senha atual é o que prova que quem está na tela
 * é a pessoa e não uma aba esquecida aberta.
 *
 * Ao salvar, a sessão cai — o Upgrade ID revoga todas, e é o comportamento
 * certo: quem troca a senha por suspeita de acesso indevido precisa que o
 * refresh token de 30 dias do invasor morra no mesmo ato.
 */
export default function Senha() {
  const trocarSenha = useAuth((s) => s.trocarSenha)
  const [atual, setAtual] = useState('')
  const [nova, setNova] = useState('')
  const [repetida, setRepetida] = useState('')
  const [erro, setErro] = useState('')
  const [indo, setIndo] = useState(false)

  async function enviar(e) {
    e.preventDefault()
    if (nova !== repetida) {
      setErro('As duas senhas novas não são iguais.')
      return
    }
    setErro(''); setIndo(true)
    try {
      // Em caso de sucesso a store limpa o token, o App volta para o login e
      // esta tela deixa de existir — daí não haver mensagem de "pronto" aqui.
      await trocarSenha(atual, nova)
    } catch (err) {
      setErro(mensagemDeErro(err))
      setIndo(false)
    }
  }

  return (
    <div className="flex flex-col gap-6">
      <Titulo sub="A senha vale para todos os produtos que autenticam pelo Upgrade ID, não só para este console.">
        Trocar senha
      </Titulo>

      <Card className="max-w-md p-6">
        <form onSubmit={enviar} className="flex flex-col gap-4">
          <input
            type="password" required value={atual} onChange={(e) => setAtual(e.target.value)}
            placeholder="senha atual" autoComplete="current-password"
            className="rounded-lg border border-zinc-300 px-3 py-2 text-sm"
          />
          <CampoDeSenha valor={nova} onChange={setNova} />
          <input
            type="password" required value={repetida} onChange={(e) => setRepetida(e.target.value)}
            placeholder="repita a senha nova" autoComplete="new-password"
            className="rounded-lg border border-zinc-300 px-3 py-2 text-sm"
          />
          <Erro>{erro}</Erro>
          <Botao type="submit" disabled={indo}>{indo ? 'salvando…' : 'Salvar'}</Botao>
          <p className="text-[11px] leading-relaxed text-zinc-400">
            Salvar encerra todas as sessões abertas, inclusive em outros aparelhos. Você vai
            precisar entrar de novo.
          </p>
        </form>
      </Card>
    </div>
  )
}
